import React, { Suspense, Fragment } from 'react';
import cx from 'classnames';
import { Switch, withRouter } from 'react-router-dom';

const blockName = 'landing-page';

const Base = props => {
  return (
    <div className={cx(blockName, 'automation-page')}>
      <Suspense fallback={<p>Loading...</p>}>
        <Switch>
          <Fragment>{props.children}</Fragment>
        </Switch>
      </Suspense>
    </div>
  );
};

export default withRouter(Base);
